import {
  checkEmail,
  sendOtpToEmail,
  updateEmail,
  verifyEmail
} from "./chunk-AKQP6RCR.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/auth/email.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";
var useSendOtpToEmail = () => {
  return useMutation({
    mutationFn: sendOtpToEmail
  });
};
var useVerifyEmail = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyEmail,
    onSuccess: () => {
      queryClient.setQueryData(["user", { lang }], (oldUser) => {
        if (oldUser) {
          return __spreadProps(__spreadValues({}, oldUser), {
            email_verified: true,
            force_verify_email: false
          });
        }
        return oldUser;
      });
    }
  });
};
var useUpdateEmail = ({ lang }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateEmail,
    onSuccess: (email) => {
      queryClient.setQueryData(["user", { lang }], (oldUser) => {
        if (oldUser) {
          return __spreadProps(__spreadValues({}, oldUser), {
            email
          });
        }
        return oldUser;
      });
    }
  });
};
var useCheckEmail = () => {
  return useMutation({
    mutationFn: checkEmail
  });
};

export {
  useSendOtpToEmail,
  useVerifyEmail,
  useUpdateEmail,
  useCheckEmail
};
//# sourceMappingURL=chunk-J2LUZ6WJ.mjs.map